var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 0v68.207H0V0h71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.377 3.59c1.692 3.19 5.988 6.312 9.546 6.936 3.557.624 6.053 4.06 5.548 7.636-.506 3.577 1.135 8.626 3.646 11.222s2.511 6.843 0 9.44c-2.51 2.595-4.152 7.645-3.646 11.221.505 3.576-1.991 7.012-5.548 7.636-3.558.624-7.854 3.746-9.546 6.936-1.693 3.19-5.732 4.503-8.977 2.916-3.245-1.585-8.555-1.585-11.8 0-3.244 1.587-7.284.274-8.977-2.916-1.692-3.19-5.988-6.312-9.546-6.936-3.556-.624-6.053-4.06-5.548-7.636.506-3.576-1.135-8.626-3.645-11.222-2.512-2.596-2.512-6.843 0-9.44 2.51-2.595 4.15-7.644 3.645-11.22-.505-3.577 1.992-7.013 5.548-7.637 3.558-.624 7.854-3.745 9.546-6.935C22.316.4 26.356-.913 29.6.674c3.244 1.586 8.554 1.586 11.799 0C44.645-.913 48.684.4 50.377 3.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0C22.508 0 29 6.492 29 14.5S22.508 29 14.5 29 0 22.508 0 14.5 6.492 0 14.5 0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0v8H0V0h9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_login_f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0A1.5 1.5 0 0 1 3 1.5v11a1.5 1.5 0 0 1-3 0v-11A1.5 1.5 0 0 1 1.5 0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_a)",
    transform: "translate(-1135 -151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_b)",
    transform: "translate(1135 151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CEB06F",
    d: "M0 0h71v68.207H0V0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_d)",
    transform: "translate(1156 171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C22.508 29 29 22.508 29 14.5S22.508 0 14.5 0 0 6.492 0 14.5 6.492 29 14.5 29Z",
    stroke: "#FFF",
    strokeWidth: 6,
    fill: "none",
    strokeMiterlimit: 5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_e)",
    transform: "translate(1166 169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h9v8H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_login_f)",
    transform: "translate(1169 169)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h3v14H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/Login-1.3b78b67c37298af64d4ee2ec19a952fa.svg";
export { ForwardRef as ReactComponent };